/* Utils */
import { createDeferredPromise } from '../../createDeferredPromise';
import importScript from '../../importScript';
import { titanOsTvModels, titanUrlDGO, titanUrlSkymais } from '../../env';

const titanOsVersions = 'titanos/1\\.0|titanos/3\\.0';
const tvModels = [...titanOsTvModels].map((model) => `|${model}`);
const combinedPartsTitan = [titanOsVersions, ...tvModels].join('');
const regexTitan = new RegExp(combinedPartsTitan, 'i');

const verifyUrlProd = () => {
  if (titanUrlDGO && titanUrlSkymais) {
    return window.location.origin.includes(titanUrlDGO)
    || window.location.origin.includes(titanUrlSkymais);
  }
  return false;
};

export function isTitan() {
  // Check code https://partners.titanos.tv/static/device-info-sdk.js
  // Check docs https://docs.titanos.tv/introduction and https://docs.titanos.tv/user-agents
  return !!window.DeviceInfo || verifyUrlProd() || regexTitan.test(navigator.userAgent);
}

const DEVICE_INFO_SDK_URL = 'https://partners.titanos.tv/static/device-info-sdk.js';
const APP_CONTROL_SKD_URL = 'https://app.titanos.tv/app2app/bridge.umd.js';
let deviceInfoSdkPromise;
let appControlSdkPromise;
export function importDeviceInfoSdk() {
  if (!deviceInfoSdkPromise) {
    deviceInfoSdkPromise = importScript(DEVICE_INFO_SDK_URL);
  }
  return deviceInfoSdkPromise;
}
export function importAppControlSdk() {
  if (!appControlSdkPromise) {
    appControlSdkPromise = importScript(APP_CONTROL_SKD_URL);
  }
  return appControlSdkPromise;
}

let deviceInfoDeferred;
export async function getDeviceInfo() {
  if (deviceInfoDeferred) return deviceInfoDeferred.promise;

  deviceInfoDeferred = createDeferredPromise();

  await importDeviceInfoSdk();

  // add app control titan
  await importAppControlSdk();

  window.onDeviceInfoReady((info) => {
    let sdkVersion;

    if (/wh1\.0|tbrowser\/2\.0|sraf\/3\.5/i.test(navigator.userAgent)) {
      sdkVersion = '1.0';
    } else {
      [, sdkVersion] = /whaletv\/([\d.]+)|whale\stv\/([\d.]+)/i.exec(navigator.userAgent) || [];
    }
    const {
      Product: { firmwareVersion, platform } = {},
      Capability: { supportUHD, supportHDR } = {},
    } = info || {};
    deviceInfoDeferred.resolve({
      version: firmwareVersion,
      sdkVersion: sdkVersion || firmwareVersion,
      modelName: platform,
      uhd: supportUHD,
      hdr: supportHDR,
    });
  });

  return deviceInfoDeferred.promise;
}
